import { useState, useEffect } from "react";
import CRM_API from "../../api/crmApi";

const COURSES = [
  "GNM (General Nursing & Midwifery)",
  "B.Sc Nursing",
  "Post Basic B.Sc Nursing (P.B.B.Sc Nursing)",
  "M.Sc Nursing",
  "BPT – Bachelor of Physiotherapy",
  "B.Sc MLT",
  "B.Sc MIT",
  "B.Sc OT & Operation Theatre Technology",
  "Diploma in Hotel Management",
  "BBA in Hotel Management",
  "Others",
];

const LEAD_SOURCES = [
  "Just Dial",
  "Whatsapp Broadcast",
  "Meta Ads",
  "Cold calling",
  "Got a call",
  "Admission Partner reference",
  "Student Refer",
  "Others",
];

// ── Shared style helpers ─────────────────────────────────────────────────────
const inputStyle = {
  width: "100%", padding: "11px 14px",
  border: "1.5px solid #e5e7eb", borderRadius: "10px",
  fontSize: "14px", color: "#111827", outline: "none",
  background: "#fff", boxSizing: "border-box",
  transition: "border-color .15s ease",
};
const labelStyle = {
  display: "block", fontSize: "12px", fontWeight: 700,
  color: "#374151", marginBottom: "6px", letterSpacing: "0.2px",
};
const sectionStyle = {
  background: "#fff", borderRadius: "14px",
  border: "1px solid #e5e7eb", marginBottom: "20px",
  overflow: "hidden",
};
const sectionHeaderStyle = {
  padding: "14px 22px", borderBottom: "1px solid #f0f4ff",
  background: "#f8faff",
};
const sectionBodyStyle = { padding: "22px" };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: "4px" }}>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────

export default function CrmAddLead({ onBack }) {
  const [users, setUsers] = useState([]);
  const [lead, setLead] = useState({
    student_name: "", student_contact: "", gender: "Male",
    qualification: "", school_name: "", year_of_passing: "",
    address: "", city: "", state: "", country: "",
    parent_name: "", parent_contact: "",
    interested_course: "", interested_location: "",
    lead_source: "", assigned_counsellor: 1,
    status: "new", temperature: "cold", next_followup: "",
  });

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    try {
      const res = await CRM_API.get("/users");
      setUsers(res.data);
    } catch (error) { console.log("Error loading users", error); }
  };

  const handleChange = (e) => setLead({ ...lead, [e.target.name]: e.target.value });

  const saveLead = async () => {
    try {
      await CRM_API.post("/leads/create", lead);
      alert("Lead Added Successfully");
      onBack();
    } catch (error) {
      console.log(error);
      alert("Failed to add lead");
    }
  };

  return (
    <div style={{ maxWidth: "860px", margin: "0 auto" }}>

      {/* Page header */}
      <div style={{ marginBottom: "28px" }}>
        <button
          onClick={onBack}
          style={{ background: "none", border: "1.5px solid #e5e7eb", borderRadius: "8px", padding: "6px 14px", color: "#6b7280", fontSize: "13px", cursor: "pointer", marginBottom: "16px", display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          <i className="bi bi-arrow-left"></i> Back to Leads
        </button>
        <h4 style={{ margin: 0, fontWeight: 800, color: "#111827", fontSize: "22px" }}>Add New Lead</h4>
        <p style={{ margin: "5px 0 0", color: "#9ca3af", fontSize: "13px" }}>Enter student details to create a new inquiry.</p>
      </div>

      {/* Section 1 — Primary Information */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={{ fontWeight: 700, fontSize: "14px", color: "#2b27ea" }}>
            <i className="bi bi-person-fill me-2"></i>Primary Information
          </span>
        </div>
        <div style={sectionBodyStyle}>
          <div className="row g-3">
            <div className="col-md-6">
              <Field label="Student Name *">
                <input style={inputStyle} name="student_name" placeholder="e.g. Rahul Sharma" value={lead.student_name} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Contact Number *">
                <input style={inputStyle} name="student_contact" placeholder="e.g. 9876543210" value={lead.student_contact} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Parent Name">
                <input style={inputStyle} name="parent_name" placeholder="e.g. Suresh Sharma" value={lead.parent_name} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Parent Contact">
                <input style={inputStyle} name="parent_contact" placeholder="e.g. 9876543211" value={lead.parent_contact} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Gender">
                <select style={inputStyle} name="gender" value={lead.gender} onChange={handleChange}>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="City">
                <input style={inputStyle} name="city" placeholder="e.g. Patna" value={lead.city} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-4">
              <Field label="State">
                <input style={inputStyle} name="state" placeholder="e.g. Bihar" value={lead.state} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-4">
              <Field label="Country">
                <input style={inputStyle} name="country" placeholder="e.g. India" value={lead.country} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-4">
              <Field label="Preferred Location">
                <input style={inputStyle} name="interested_location" placeholder="e.g. Delhi" value={lead.interested_location} onChange={handleChange} />
              </Field>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 — Academic Details */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={{ fontWeight: 700, fontSize: "14px", color: "#0891b2" }}>
            <i className="bi bi-mortarboard-fill me-2"></i>Academic &amp; Personal Details
          </span>
        </div>
        <div style={sectionBodyStyle}>
          <div className="row g-3">
            <div className="col-md-6">
              <Field label="Current Qualification">
                <input style={inputStyle} name="qualification" placeholder="e.g. 12th / Graduated" value={lead.qualification} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="School / College Name">
                <input style={inputStyle} name="school_name" placeholder="e.g. St. Xavier's School" value={lead.school_name} onChange={handleChange} />
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Year of Passing">
                <select style={inputStyle} name="year_of_passing" value={lead.year_of_passing} onChange={handleChange}>
                  <option value="">Select Year</option>
                  {Array.from({ length: 86 }, (_, i) => {
                    const year = new Date().getFullYear() + 6 - i;
                    return <option key={year} value={year}>{year}</option>;
                  })}
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Address">
                <input style={inputStyle} name="address" placeholder="Full address" value={lead.address} onChange={handleChange} />
              </Field>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 — Interest & CRM */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={{ fontWeight: 700, fontSize: "14px", color: "#7c3aed" }}>
            <i className="bi bi-diagram-3-fill me-2"></i>Interest &amp; CRM Assignment
          </span>
        </div>
        <div style={sectionBodyStyle}>
          <div className="row g-3">
            <div className="col-md-6">
              <Field label="Interested Course">
                <select style={inputStyle} name="interested_course" value={lead.interested_course} onChange={handleChange}>
                  <option value="">Select Course</option>
                  {COURSES.map(c => <option key={c}>{c}</option>)}
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Lead Source">
                <select style={inputStyle} name="lead_source" value={lead.lead_source} onChange={handleChange}>
                  <option value="">Select Source</option>
                  {LEAD_SOURCES.map(s => <option key={s}>{s}</option>)}
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Assign to Counsellor">
                <select style={inputStyle} name="assigned_counsellor" value={lead.assigned_counsellor} onChange={handleChange}>
                  <option value="">Unassigned</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.full_name}</option>)}
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Temperature">
                <select style={inputStyle} name="temperature" value={lead.temperature} onChange={handleChange}>
                  <option value="cold">🔵 Cold</option>
                  <option value="warm">🟡 Warm</option>
                  <option value="hot">🔥 Hot</option>
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Status">
                <select style={inputStyle} name="status" value={lead.status} onChange={handleChange}>
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="interested">Interested</option>
                  <option value="converted">Converted</option>
                  <option value="dropped">Dropped</option>
                </select>
              </Field>
            </div>
            <div className="col-md-6">
              <Field label="Next Follow-up Date">
                <input type="date" style={inputStyle} name="next_followup" value={lead.next_followup} onChange={handleChange} />
              </Field>
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "8px" }}>
        <button
          onClick={onBack}
          style={{ padding: "11px 28px", borderRadius: "10px", border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: "14px", fontWeight: 600, cursor: "pointer" }}
        >
          Cancel
        </button>
        <button
          onClick={saveLead}
          style={{ padding: "11px 32px", borderRadius: "10px", border: "none", background: "linear-gradient(135deg,#2b27ea,#069ee6)", color: "#fff", fontSize: "14px", fontWeight: 700, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "7px", boxShadow: "0 4px 14px rgba(43,39,234,.35)" }}
        >
          <i className="bi bi-floppy-fill"></i> Save Lead
        </button>
      </div>
    </div>
  );
}
